import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "wrapCard fill-height",
  style: {"background-color":"rgba(0, 0, 0, 0.4)"}
}

import { ref } from "vue";
import { useDisplay } from "vuetify";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { xs } = useDisplay();

const necessities = ref([
  {
    reveal: false,
    title: "코로나 19 감염 후 <br /> 치매 위험 2배 가량 증가",
    content:
      "장기간 지속되는 인지기능장애가 나타날 수 있으며 이는 노인 환자에서 치매증상을 유발할 수 있습니다. 특히 뇌혈관 질환, 무증상 알츠하이머병, 파킨슨병 등 기저 신경혈관 질환이 있는 노인환자에서 급성 섬망처럼 치매 관련 증상이 나타나는 경우가 많습니다. <br /> 출처 : 알츠하이머 협회 저널 <br /> 헬스인뉴스(http://www.healthinnews.co.kr)",
    imageUrl: require("../../assets/main/main_card_1.webp"),
  },
  {
    reveal: false,
    title: "늘어가는 치매 관리 비용",
    content:
      "보건복지부에 따르면 2017년 치매 환자 수는 72만명, 치매 관리 비용은 15조원으로 통계되었습니다. 2020년에는 환자 수 84만명, 관리비용은 19조원으로 2050년에는 303만명, 107조원으로 환자와 비용이 증가할 전망으로 발표했습니다.",
    imageUrl: require("../../assets/main/main_card_2.webp"),
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { style: {"max-width":"1200px","position":"absolute","z-index":"-1"} }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { justify: "space-between" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(necessities.value, (necessity, index) => {
                    return (_openBlock(), _createBlock(_component_v_col, {
                      key: index,
                      cols: "12",
                      sm: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: "mx-auto rounded-lg fill-height",
                          id: "cardHeight"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                              _createVNode(_component_v_card_text, {
                                id: "cardTextHeight",
                                class: _normalizeClass(["pa-8 text-white", { 'text-body-1': _unref(xs) }]),
                                style: {"line-height":"1.5","word-break":"keep-all","font-size":"1.15rem"},
                                innerHTML: necessity.content
                              }, null, 8, ["class", "innerHTML"]),
                              _createVNode(_component_v_card_actions, { style: {"flex-direction":"row-reverse","align-items":"flex-end"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    icon: "mdi-close-circle-outline",
                                    color: "#FFFFFF99",
                                    size: "x-large"
                                  })
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})